// Polyfill
import "intersection-observer";
import objectFitImages from "object-fit-images";
import closetPolyfill from "./lib/closet.polyfill";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

objectFitImages();
closetPolyfill();

// Libraly
import Loading from "./lib/Loading";
// import $ from "jquery";
// import Swiper from 'swiper';
import SmoothScroll from "smooth-scroll";
import ScrollObserver from "./lib/ScrollObserver";
// import Toggle from "./lib/Toggle";
// import Close from "./lib/Close";
// import Slider from "./lib/Slider";
// import { dropdown } from './lib/dropdown';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

new Loading();

/* ==============================
// 1番右にスクロールさせたいの xPercent で 100% 指定
============================== */
gsap.config({
  nullTargetWarn: false,
});

const a1 = gsap
  .to(".p-service__animation__item", {
    xPercent: 100,
    duration: 10,
    repeat: -1,
    ease: "none",
  })
  .seek(100);

ScrollTrigger.create({
  trigger: ".p-service__animation__item",
  start: "-99999 top",
  onUpdate: (self) => {
    self.direction === -1 ? a1.reverse() : a1.play();
  },
});
/* ==============================
adobeフォントのちらつきの設定
============================== */
setTimeout(function () {
  if (document.getElementsByTagName("html")[0].classList.contains("wf-active") != true) {
    document.getElementsByTagName("body")[0].classList.add("is-loaded");
  }
}, 3000);

/* ==============================
スムーススクロールの設定
============================== */
let options = {
  speed: 10,
  // easing: "Linear",
  offset: 150,
  speedAsDuration: true,
};
new SmoothScroll('a[href*="#"]', options);

/* ==============================
ハンバーガーメニューの設定
============================== */
// new Toggle(".js-drawer");

// WordPressの既存のjquery採用;
jQuery(function ($) {
  /* ==============================
    Drawer
  ============================== */
  $(".js-drawer").click(function () {
    $("body").toggleClass("is-drawerActive");
    $("#globalNav").toggleClass("is-drawerActive");

    let elem = $(".p-globalNav");
    if ($(this).attr("aria-expanded") == "false") {
      disableBodyScroll(elem);
      $(this).attr("aria-expanded", true);
    } else {
      clearAllBodyScrollLocks();
      $(this).attr("aria-expanded", false);
    }
  });

  /* ==============================
    グローバルメニューの固定
  ============================== */

  function scrollFix() {
    var navPos = $("#globalNav").offset().top; // グローバルメニューの位置
    var navHeight = $("#globalNav").outerHeight(); // グローバルメニューの高さ
    $(window).on("scroll", function () {
      if (window.matchMedia("(min-width: 992px)").matches) {
        if ($(this).scrollTop() > navPos) {
          $("body").css("padding-top", navHeight);
          $("#globalNav").addClass("is-fixed");
        } else {
          $("body").css("padding-top", 0);
          $("#globalNav").removeClass("is-fixed");
        }
      } else {
        $("#globalNav").removeClass("is-fixed");
        $("body").css("padding-top", 0);
      }
    });
  }
  scrollFix();
  window.addEventListener("resize", scrollFix);
});

/* ==============================
// intersectionのアニメーション実装
============================== */
import { inview } from "./lib/inview";
// inview(".c-inview");
new ScrollObserver(".c-inview", inview);

/* ==============================
// メインビジュアルの100vhの--vhを定義
============================== */

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

window.addEventListener("resize", setFillHeight);

// 初期化
setFillHeight();
